module.exports = __webpack_public_path__ + "media/landings/empty-cart-bd806d05.svg";